export const elementsCacheByHash: Record<string, NooBack.Content.ContentElement> = {};
export const imagesCacheById: Record<string, any> = {};
